import * as o from "react";
import e from "../lib/IconBase.es.js";
import t from "../defs/Hourglass.es.js";
const r = o.forwardRef((s, a) => /* @__PURE__ */ o.createElement(e, { ref: a, ...s, weights: t }));
r.displayName = "HourglassIcon";
const n = r;
export {
  n as Hourglass,
  r as HourglassIcon
};
